import UploadedFiles from './UploadedFiles';

export default UploadedFiles;
